let currentOverlay = null;
let currentZoomImage = null;
let lockedSwiper = null;
const ZOOM_RATIO = 2;
const MOBILE_MAX_WIDTH = 767;

function isMobileViewport() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
}

function getProductGallerySwiper(image) {
  const slider = image?.closest(".pdp_slider, .mobile_pdp_slider");
  return slider?.swiper || null;
}

function lockProductGallerySwiper(image) {
  if (!isMobileViewport()) return;

  const slider = image?.closest(".pdp_slider, .mobile_pdp_slider");
  const swiper = slider?.swiper;
  if (!swiper || typeof swiper.disable !== "function") return;

  lockedSwiper = swiper;
  slider.classList.add("is-magnify-active");
  swiper.disable();
}

function unlockProductGallerySwiper() {
  if (!lockedSwiper) return;

  const slider = lockedSwiper.el;
  if (typeof lockedSwiper.enable === "function") {
    lockedSwiper.enable();
  }
  if (slider) {
    slider.classList.remove("is-magnify-active");
  }
  lockedSwiper = null;
}

function closeMagnify(image) {
  if (currentOverlay) {
    currentOverlay.remove();
    currentOverlay = null;
  }
  if (image) {
    image.style.opacity = "100%";
  }
  unlockProductGallerySwiper();
  currentZoomImage = null;
}

function createOverlay(image) {
  const overlayImage = document.createElement("img");
  overlayImage.setAttribute("src", `${image.src}`);
  const overlay = document.createElement("div");
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = "50%";
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = "100%";
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute("class", "image-magnify-full-size");
  container.setAttribute("aria-hidden", "true");
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = "var(--gradient-background)";
}

function toggleLoadingSpinner(image) {
  const loadingSpinner =
    image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) {
    loadingSpinner.classList.toggle("hidden");
  }
}

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  if (currentOverlay) {
    currentOverlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    currentOverlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
}

function magnify(image, zoomRatio) {
  if (currentOverlay) {
    closeMagnify(image);
    return;
  }

  currentZoomImage = image;
  lockProductGallerySwiper(image);

  currentOverlay = createOverlay(image);
  currentOverlay.onclick = () => closeMagnify(image);
  currentOverlay.onmousemove = (event) =>
    moveWithHover(image, event, zoomRatio);
  currentOverlay.ontouchmove = (event) => {
    if (!event.touches.length) return;
    event.preventDefault();
    const touch = event.touches[0];
    moveWithHover(
      image,
      { target: image, clientX: touch.clientX, clientY: touch.clientY },
      zoomRatio,
    );
  };
  currentOverlay.onmouseleave = () => {
    if (currentOverlay) {
      closeMagnify(image);
    }
  };
}

function getMagnifyImageFromButton(button) {
  const container = button.closest(".product-image-magnify-wrap");
  return container ? container.querySelector(".image-magnify-hover") : null;
}

function triggerMagnifyFromButton(button, zoomRatio) {
  const image = getMagnifyImageFromButton(button);
  if (!image) return;

  const rect = image.getBoundingClientRect();
  const event = {
    target: image,
    clientX: rect.left + rect.width / 2,
    clientY: rect.top + rect.height / 2,
  };

  magnify(image, zoomRatio);
  if (currentOverlay) {
    moveWithHover(image, event, zoomRatio);
  }
}

function enableProductMagnifyButtons(zoomRatio) {
  document.querySelectorAll(".product-magnify-btn").forEach((button) => {
    if (button.dataset.magnifyBound === "true") return;
    button.dataset.magnifyBound = "true";
    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      triggerMagnifyFromButton(button, zoomRatio);
    });
  });
}

function initProductMagnify(zoomRatio) {
  enableProductMagnifyButtons(zoomRatio);
}

initProductMagnify(ZOOM_RATIO);

document.addEventListener("shopify:section:load", () => {
  initProductMagnify(ZOOM_RATIO);
});

document.addEventListener("fuzion-product-gallery-swiper-ready", () => {
  initProductMagnify(ZOOM_RATIO);
});

window.addEventListener("resize", () => {
  if (!currentOverlay || !currentZoomImage) return;
  if (!isMobileViewport()) {
    unlockProductGallerySwiper();
    return;
  }
  if (!lockedSwiper) {
    lockProductGallerySwiper(currentZoomImage);
  }
});
